function getFragmentBase(name) {
  return `/fragments/${name}`;
}
function getFragmentUrl(name, version) {
  return `${getFragmentBase(name)}/${version}`;
}
function joinPath(...parts) {
  return parts.reduce((left, right) => {
    if (left && right) {
      return `${left.replace(/\/$/g, "")}/${right.replace(/^\//g, "")}`;
    }
    return `${left}${right}`;
  });
}
function cleanSlash(path) {
  return path.replace(/\/+$/g, "");
}
function isPathsEqual(path1, path2) {
  return cleanSlash(path1) === cleanSlash(path2);
}
export {
  getFragmentUrl as a,
  cleanSlash as c,
  getFragmentBase as g,
  isPathsEqual as i,
  joinPath as j
};
//# sourceMappingURL=path.js.map
